import React from 'react'
import { Ref, Item } from 'semantic-ui-react'

const ForwardedHeader = React.forwardRef((props, ref) => (
  <Ref innerRef={ref}>
    <Item.Header {...props} />
  </Ref>
))

export default ForwardedHeader
